var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "white-list" } },
    [
      _c("supsis-table", {
        attrs: { columns: _vm.cols(), rows: _vm.getFilteredRows() },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("a-input-search", {
                      staticClass: "search-input",
                      attrs: { placeholder: _vm.$t("message.search") },
                      on: { search: _vm.onSearch },
                      model: {
                        value: _vm.searchText,
                        callback: function ($$v) {
                          _vm.searchText = $$v
                        },
                        expression: "searchText",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { ghost: "" },
                        on: { click: _vm.showModalWithoutEdit },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("settings.whiteListAdd")) +
                            "\n                    "
                        ),
                        _c("md-icon", [_vm._v("add")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "white-list-form",
                title: _vm.$t("settings.whiteList"),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "ipAddress" } }, [_vm._v("IP")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ip-address" },
                  [
                    _c("a-input", {
                      attrs: { id: "ipAddress", placeholder: "0.0.0.0" },
                      model: {
                        value: _vm.form.ipAddress,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "ipAddress", $$v)
                        },
                        expression: "form.ipAddress",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.takeIpAddress },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("settings.ipAddress")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "description" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.description"))),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: { id: "description" },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(
                    "SupsisButton",
                    { attrs: { primary: "" }, on: { click: _vm.handleSave } },
                    [_vm._v(" " + _vm._s(_vm.$t("message.save")) + " ")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }